export default {
  "content": "<path d=\"M7.71.29L6.3 1.7 11.59 7H0v2h11.59L6.3 14.29l1.41 1.41 7-7a.996.996 0 000-1.41l-7-7z\" fill=\"#006AFF\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};